<template lang="pug">
  include ./../../../../mixins
  +b.stats
    +e.header
      +b.ug-row--apearance_spaced.--space_xs.--justify_between.--align_center
        +b.ug-cell
          +b.TEXT-BEMTO(
            :fw="'bold'"
            :lh="'initial'"
            :fs="['md', '1md-md', 'xl-fhd']"
            :color="'black'"
            :tag="'p'"
          ) 7 DAY STATISTICS
        +b.ug-cell
          +b.stats__icon.icon--type_stats
    +e.body--flexible
      +e.content--left
        +b.ma--b_xs.TEXT-BEMTO(
          :fw="'medium'"
          :lh="'initial'"
          :fs="['xs', '1md-xl']"
          :color="'black'"
          :tag="'p'"
        ) Total Deposits Received:
        +b.TEXT-BEMTO(
          :fw="'bold'"
          :lh="'initial'"
          :fs="['4xl', '5xl-mac', '6xl-fhd']"
          :color="'black'"
          :tag="'p'"
        ) {{ objectItem.total }} &#163
      +e.content--right.--line
        +b.ma--b_xs.--b_sm-mac.TEXT-BEMTO(
          :fw="'medium'"
          :lh="'initial'"
          :fs="['xs', '1md-xl']"
          :color="'black'"
          :tag="'p'"
        ) Jobs:
        +b.TEXT-BEMTO(
          :fw="'medum'"
          :lh="'initial'"
          :fs="['xl']"
          :color="'black'"
          :tag="'p'"
        ) {{ objectItem.count }}
</template>

<script>
export default {
  name: 'DayStatsPanel',
  props: [
    'objectItem',
  ],
}
</script>



// WEBPACK FOOTER //
// src/js/components/Forms/cabinets/panels/DayStatsPanel.vue